import Downloads from './Downloads';

export default function Infographics() {
    return (
        <Downloads
            titleLead="Our"
            titleBold="Infographics"
            intro="The numbers behind the work, drawn out. Share-ready visuals on court performance, case turnaround and access to justice."
            basePath="/resources/infographics"
            label="All Infographics"
            topLabel="Top Infographic"
            recentLabel="Recent Infographics"
        />
    );
}
